<template>
    <v-dialog max-width="500" v-model="dialog">
        <v-card :title="$t('are_you_sure')">
        <v-card-text>
            {{ $t("your_design_will_be_removed") }}
        </v-card-text>
        <v-carousel
            class=" pa-0 border-thin rounded"
            hide-delimiters
            :show-arrows="true"
            height="auto"
            v-model="carouselIndex">
                <v-carousel-item
                class="ma-5 pa-5"
                
                v-for="(data, index) in currentImageData"
                :key="index"
                v-show="true"
                >
                    
                    <product-mockup
                    :key="data"
                    :base64Image="product.base64Material"
                    :modelPath="modelPath"
                    :aspect-ratio="1"
                    :currentImageData="data"
                    :MainMaterialLayername = MainMaterialLayername
                    :MainMaterialWidth = MainMaterialWidth
                    :MainMaterialHeight = MainMaterialHeight
                    :is3d="this.baseProduct.Is3d"
                    />
                
                </v-carousel-item>
            </v-carousel>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            prepend-icon="mdi-delete"
            variant=""
            color="error"
            @click="removeItem();dialog = false"
            >
            {{$t('remove')}}
            </v-btn>
            <v-btn
            color="primary"
            variant="outlined"
            @click="dialog = false"
            >
            {{$t('keep_in_cart')}}
        </v-btn>

        </v-card-actions>
        </v-card>
    </v-dialog>
    <v-row v-if="!loading" no-gutters>
        <v-col
        cols="3"
        >
        <v-carousel
            class=" pa-0 border-thin rounded"
            hide-delimiters
            :show-arrows="false"
            height="auto"
            v-model="carouselIndex">
                <v-carousel-item
                class="ma-0 pa-0"
                
                v-for="(data, index) in currentImageData"
                :key="index"
                v-show="true"
                > 
                    <product-mockup
                    :key="data"
                    :base64Image="product.base64Material"
                    :modelPath="modelPath"
                    :aspect-ratio="1"
                    :currentImageData="data"
                    :MainMaterialLayername = MainMaterialLayername
                    :MainMaterialWidth = MainMaterialWidth
                    :MainMaterialHeight = MainMaterialHeight
                    :is3d="this.baseProduct.Is3d"
                    @image-ready="collectImage"
                    />
                
                </v-carousel-item>
            </v-carousel>
       </v-col>
       <v-col cols="9">
        <v-row no-gutters>
            <v-col cols="12">
                <div align="left"  class=" ml-3 text-subtitle text-truncate font-weight-bold"
                style="max-width: 100%; ;">{{this.baseProduct.Name[this.$i18n.locale]}} </div>
            </v-col>
            <v-col cols="12">
                <div align="left" style="font-size: small !important;" class=" ml-3  text-subtitle-2 text-truncate"
               >{{this.productSize}} / {{ this.productColor }} </div>
            </v-col>
            <v-col cols="12">
                <v-row no-gutters class="d-flex align-end">
                    <v-col cols="12" md="6" align="left">
                        <v-card
                            class="ml-3 d-flex align-center justify-center pa-1 rounded-md mt-2"
                            elevation="0"
                            style="max-width: 90px; height: 30px; background-color: #efede9;"
                            >
                            <template v-if="cartItem.quantity === 1">
                                <v-btn
                                icon
                                size="small"
                                variant="text"
                                @click="dialog=true"
                                >
                                <v-icon size="20" color="">mdi-delete-outline</v-icon>
                                </v-btn>
                            </template>
                            <template v-else>
                                <v-btn
                                icon
                                size="small"
                                variant="text"
                                @click="quantityDown"
                                >
                                <v-icon size="20" color="primary">mdi-minus</v-icon>
                                </v-btn>
                            </template>

                            <span class="mx-2 text-subtitle-2">{{ cartItem.quantity }}</span>

                            <v-btn
                                icon
                                size="small"
                                variant="text"
                                @click="quantityUp"
                            >
                                <v-icon size="20" color="primary">mdi-plus</v-icon>
                            </v-btn>
                            </v-card>
                    </v-col>
                    <v-col cols="12" md="6" align="left">
              
                        <v-skeleton-loader
                            :loading="cartLoading"
                            class="mx-auto"
                            elevation="0"
                            max-width="200"
                            type="heading"
                        >
                        <div translate="no" class="text-subtitle-1 font-weight-bold pa-0 ma-0 ml-3 ">
                                € {{ (Number(this.cartItem.totalPrice).toFixed(2)) }} 
                                <span translate="no" style="font-size: x-small !important;     line-height: 0.70;"  v-if="this.baseProduct.originalPrice" class="text-decoration-line-through">€ {{ (Number(this.baseProduct.originalPrice) * this.cartItem.quantity).toFixed(2) }}</span>
                                <span  style="font-size: x-small !important;"  class="pl-2">{{ $t("incl") }} VAT</span>
                        </div>
                    </v-skeleton-loader>
                     

                    </v-col>
        
                </v-row>
            </v-col>
        </v-row>
       </v-col>
    </v-row>
    <v-row v-if="loading">
        <v-col cols="12">
            <v-skeleton-loader type="list-item-avatar" :loading="loading"></v-skeleton-loader>
        </v-col>
    </v-row>
</template>
  
<script>
    //import staticImageUpload from './staticImageUpload.vue';
    import axios from 'axios';
    import ProductMockup from '../components/ProductMockup.vue'; // Adjust the import path as necessary
    import mugModelPath from '../assets/mug.glb'; // Import the GLB model 
    import mugPrintfulModelPath from '../assets/Printful_11_oz_mug.glb'; // Import the GLB model 
    import bottelModelPath from '../assets/bottel.glb'; // Import the GLB model 
  //  import { debounce } from 'lodash';
  //  import countries from '@/assets/countries.json'; 
  //  import { trackEvent } from '@/services/amplitudeService';


 export default {
    

   components:{ProductMockup},
   props: {

     cartItem:{
      type: Object,
      required: true
     },


   },
   async created() {
   
   await this.getProduct(this.cartItem.userProductID);
   },
   mounted(){

   },
   data() {
     return {
        product:{},
        baseProduct:{},
        currentImageData:[],
        MainMaterialLayername:null,
        MainMaterialWidth:null,
        MainMaterialHeight:null,
        email:'',
        loading:false,
        carouselIndex:0,
        productSize: null,
        productColor: null,
        dialog:false,
        cartLoading:false,
        collectedImages: [],
        
     
     };
   },
   watch: {

   },
   methods: {
    async getProduct(userProductID) {
            this.loading = true;  // Show loading dialog
            const token = this.$store.getters.getToken; 
            try {
            //WARNING confusing ID or Id fix this later
            const response = await axios.get(`/apis/getSingleProduct/${userProductID}`, {
            headers: {
            Authorization: token
            }
            });
            this.product = response.data;
            const productResponce = await axios.get(`/apis/product/${this.product.productID}`);
            this.baseProduct = productResponce.data;
            this.currentImageData = productResponce.data.imagesData;
            this.MainMaterialLayername = productResponce.data.MainMaterialLayername;
            this.MainMaterialWidth = productResponce.data.MainMaterialWidth;
            this.MainMaterialHeight = productResponce.data.MainMaterialHeight;
            this.product.base64Material = `data:image/png;base64,${this.product.base64Material}`;
            this.product.base64Image =  `data:image/png;base64,${this.product.base64Image}`;

            for (let size of this.baseProduct.variants.sizes) {
            if (size.colors) {
                // Loop through each color in the size
                for (let color of size.colors) {
                // Check if the external product ID matches
                if (color.external_product_id === this.cartItem.variantID      ) {
                    // Return the imagesData array if found
                    this.currentImageData = color.imagesData || [];
                    this.productSize = size.size;
                    this.productColor = color.color_name;
                
                }
                }
            }
            }

            if(productResponce.data.Category === 'bottles'){
                this.modelPath = bottelModelPath;
            }else if (productResponce.data.Category === 'mugs' && productResponce.data.pod ==='Gelato') {
                this.modelPath = mugModelPath;
            }else if (productResponce.data.Category === 'mugs' && productResponce.data.pod ==='Printful'){
                this.modelPath = mugPrintfulModelPath;
            }
            } catch (error) {
            console.error('Error fetching designs:', error);
            //SHOW ERROR IN CART
            //this.$router.push({ name: '404BadPage',query: { ...this.$route.query } });
            } finally {
            
            this.email = this.product.userEmail;
            this.loading = false;  // Hide loading dialog
            
            }
   },
   quantityUp(){
    this.cartLoading = true;
    try{
      this.$store.dispatch('updateCartItemQuantity', {
      userProductID: this.cartItem.userProductID,
      variantID: this.cartItem.variantID,
      newQuantity: Number(this.cartItem.quantity+1)
      });
    }finally{
        this.cartLoading = false;
    }

   },
   quantityDown(){
    try{
        this.cartLoading = true;
        if(this.cartItem.quantity>1){
        this.$store.dispatch('updateCartItemQuantity', {
        userProductID: this.cartItem.userProductID,
        variantID: this.cartItem.variantID,
        newQuantity: Number(this.cartItem.quantity-1)
        });   
       }
    }
    finally{
        this.cartLoading = false;
    }

   },
   removeItem(){
         this.cartLoading = true;
         try{
            this.$store.dispatch('removeCartItem', {
                userProductID: this.cartItem.userProductID,
                variantID: this.cartItem.variantID,
            }); 

         }finally{
            this.cartLoading = false;
         }
  
    },
    async uploadThumbnails() {
        const  userProductID  = this.cartItem.userProductID;
        const token = this.$store.getters.getToken; 
        const formData = new FormData();
        formData.append('userProductID', userProductID);
        const file1 = this.base64ToFile(this.collectedImages[0], 'image1.png');
        formData.append('image', file1);
        try {
          await axios.post('/apis/uploadProductThumbnail', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: token, // Pass the JWT token
            },
          });
    
        } catch (error) {
          console.error(error);
         
        }
    },
    collectImage(base64Image) {
          // Store the image if less than 3 images are collected
          if (this.collectedImages.length < 1) {
            this.collectedImages.push(base64Image);
            this.uploadThumbnails();
          }
    },
    base64ToFile(base64String, filename) {
  const arr = base64String.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
},

   },

 };
 </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  